 document.addEventListener("DOMContentLoaded", function () {
     function updateTimer() {
        const now = new Date().getTime();
        const targetDate = new Date("2026-10-15T10:00:00").getTime();
       const timeLeft = targetDate - now;

        // Pobierz wszystkie timery
        const timers = document.querySelectorAll(".countdown-timer");

         timers.forEach(timer => {
             if (timeLeft > 0) {
                const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

               timer.querySelector(".days").textContent = days;
                timer.querySelector(".hours").textContent = hours;
                timer.querySelector(".minutes").textContent = minutes;
                 timer.querySelector(".seconds").textContent = seconds;
            } else {
                 timer.textContent = "Nie przegap!";
             }
        });
    }

     updateTimer();
    setInterval(updateTimer, 1000);
 });